import { castToModel } from "../providers/utils-provider.service";
import { ParticipantModel, ParticipantModelData } from "./participant-model";
import { MessageModel, MessageModelData } from "./message-model";
import { User } from "./user";

export interface DiscussionModelData {
  _id?: number;
  _reference?: string;
  _name?: string;
  _owner?: ParticipantModelData;
  _latestMessage?: MessageModelData;
  _participants?: ParticipantModelData[];
  _unseenMessages?: number;
}
export class DiscussionModel {
  id?: number;
  reference?: string;
  name?: string;
  owner?: ParticipantModel;
  latestMessage?: MessageModel;
  participants?: ParticipantModel[];
  unseenMessages: number;


  public static fromApi(data: DiscussionModelData): DiscussionModel {
    return new DiscussionModel(data);
  }

  public static fromApiList(data: DiscussionModelData[]): DiscussionModel[] {
    return data.map((item: DiscussionModelData) => DiscussionModel.fromApi(item));
  }

  constructor({_id, _reference, _name, _owner, _latestMessage, _participants, _unseenMessages}: DiscussionModelData) {
    this.id = _id;
    this.reference = _reference;
    this.name = _name;
    this.owner = _owner ? ParticipantModel.fromApi(_owner) : undefined;
    this.latestMessage = _latestMessage ? MessageModel.fromAPI(_latestMessage) : undefined;
    this.participants = _participants ? ParticipantModel.fromApiList(_participants) : [];
    this.unseenMessages = _unseenMessages ?? 0;
  }


  public get isGroup(): boolean {
    return null !== this.name;
  }

  public get displayName(): string {
    if (this.isGroup) {
      return this.name ?? '-';
    }

    const participant: ParticipantModel | undefined = this.recipient;

    return participant?.user?.firstName + ' ' + participant?.user?.lastName;
  }

  public get recipient(): ParticipantModel | undefined {
    return this.participants?.slice(0, 1)[0];
  }
}
